import Result from 'components/GlobalSearch/GlobalResult';
import React, { FunctionComponent } from 'react';
import PrivatePage from './PrivatePage';

interface GlobalResultProps {
    query: string;
}

export const GlobalResult: FunctionComponent<GlobalResultProps> = props => {
    return (
        <PrivatePage
            title="Global Result - Cuddles"
            pageName="/globalResult"
        >
            <Result query={props.query} />
        </PrivatePage>
    );
};

export default GlobalResult;
